import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const CorpusChristi = () => {
  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Valves Corpus Christi | Industrial Equipment Buyers Corpus Christi Texas';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We buy valves Corpus Christi Texas - Professional valve buyers in Corpus Christi. We buy surplus valves, Fisher control valves, instrumentation from Flint Hills, Citgo refineries. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers corpus christi, texas industrial equipment, surplus valves corpus christi, fisher control valves texas, refinery equipment buyers');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/corpus-christi');
    }
    
    // Add geo and schema data
    const geoPosition = document.createElement('meta');
    geoPosition.setAttribute('name', 'geo.position');
    geoPosition.setAttribute('content', '27.8006;-97.3964');
    document.head.appendChild(geoPosition);

    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-TX');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'Corpus Christi, Texas');
    document.head.appendChild(geoPlacename);

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/corpus-christi/#webpage",
          "url": "https://valvesalessupply.com/corpus-christi",
          "name": "Corpus Christi Texas Valve Buyers - Industrial Equipment Buyers | ValveSalesSupply",
          "description": "Professional valve buyers Corpus Christi Texas - We buy surplus valves, Fisher control valves, instrumentation from Flint Hills, Citgo refineries. Same-day response 214-854-5638."
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in Corpus Christi Texas?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from Corpus Christi area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Flint Hills Resources, Citgo, and other South Texas refineries."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(geoPosition);
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const faqData = [
    {
      question: "What types of valves do you buy in Corpus Christi Texas?",
      answer: "We buy all types of industrial valves from Corpus Christi area refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Flint Hills Resources, Citgo, and other South Texas refineries."
    },
    {
      question: "How quickly can you respond to South Texas refineries?",
      answer: "We provide same-day response to all Corpus Christi and South Texas facilities. Our Texas team can typically be on-site within 2-4 hours for equipment assessments. We understand the unique operational schedules of coastal refineries."
    },
    {
      question: "Do you buy marine terminal equipment from Corpus Christi?",
      answer: "Yes! We purchase marine loading equipment, pipeline valves, tank farm instrumentation, and terminal equipment from Corpus Christi port facilities. We handle both refinery and terminal equipment with proper marine documentation."
    },
    {
      question: "What documentation is required for Texas coastal facilities?",
      answer: "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with Texas coastal regulations."
    },
    {
      question: "Do you coordinate with hurricane season shutdowns?",
      answer: "Absolutely! We understand Gulf Coast weather patterns and can coordinate equipment removal during hurricane preparation or post-storm recovery periods. Our team is experienced with emergency equipment purchases during weather events."
    },
    {
      question: "How do you price equipment from Corpus Christi refineries?",
      answer: "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all South Texas facilities."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/41afb3f3156fad7fd4e742b3c09bffe3.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves Corpus Christi Texas</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers Corpus Christi</strong> South Texas - We purchase surplus valves, control valves, 
              instrumentation, and refinery equipment from Flint Hills Resources, Citgo, and coastal refineries. 
              Same-day response and competitive pricing for all South Texas facilities.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET CORPUS CHRISTI QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Our Service Coverage in Corpus Christi
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide equipment pickup services throughout the greater Corpus Christi metropolitan area
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">North Corpus Christi</h3>
              <p className="text-gray-600">Refinery Row, Eastside, Clarkwood areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">South Corpus Christi</h3>
              <p className="text-gray-600">Southside, Flour Bluff, OSO areas</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">West Corpus Christi</h3>
              <p className="text-gray-600">Calallen, Annaville, Robstown areas</p>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Buy in Corpus Christi
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We purchase top-quality refinery and petrochemical equipment from leading manufacturers in Corpus Christi, Texas
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-lg border border-orange-100">
              <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Refinery Valves Corpus</h3>
              <p className="text-gray-600 mb-4">
                Fisher Control Valves Corpus Christi, Masoneilan Corpus, Q-Check Corpus, Valtek Corpus Christi
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Fisher Corpus</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Masoneilan Corpus</span>
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-sm rounded">Q-Check Corpus</span>
              </div>
              <a href="/contact" className="text-orange-600 hover:text-orange-700 font-medium">Get Corpus Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-lg border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-dashboard-3-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Instrumentation Corpus</h3>
              <p className="text-gray-600 mb-4">
                Rosemount Transmitters Corpus Christi, Foxboro Corpus, Fisher Instruments Corpus, Barton Corpus
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Rosemount Corpus</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Foxboro Corpus</span>
                <span className="px-2 py-1 bg-green-100 text-green-800 text-sm rounded">Fisher Corpus</span>
              </div>
              <a href="/contact" className="text-green-600 hover:text-green-700 font-medium">Get Corpus Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-6 rounded-lg border border-blue-100">
              <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-water-percent-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Flow Systems Corpus</h3>
              <p className="text-gray-600 mb-4">
                Badger Meters Corpus Christi, Neptune Corpus, Rockwell Corpus, petrochemical flow equipment
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Badger Corpus</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Neptune Corpus</span>
                <span className="px-2 py-1 bg-blue-100 text-blue-800 text-sm rounded">Rockwell Corpus</span>
              </div>
              <a href="/contact" className="text-blue-600 hover:text-blue-700 font-medium">Get Corpus Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 p-6 rounded-lg border border-purple-100">
              <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-cpu-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Actuators Corpus</h3>
              <p className="text-gray-600 mb-4">
                Limitorque Corpus Christi, Bettis Actuators Corpus, Fisher Actuators Corpus, Q-Check Corpus
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Limitorque Corpus</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Bettis Corpus</span>
                <span className="px-2 py-1 bg-purple-100 text-purple-800 text-sm rounded">Fisher Corpus</span>
              </div>
              <a href="/contact" className="text-purple-600 hover:text-purple-700 font-medium">Get Corpus Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 p-6 rounded-lg border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plug-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Fittings Corpus</h3>
              <p className="text-gray-600 mb-4">
                Swagelok Corpus Christi, Parker Fittings Corpus, Anderson Greenwood Corpus, Hoke Corpus
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Swagelok Corpus</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Parker Corpus</span>
                <span className="px-2 py-1 bg-teal-100 text-teal-800 text-sm rounded">Anderson Corpus</span>
              </div>
              <a href="/contact" className="text-teal-600 hover:text-teal-700 font-medium">Get Corpus Quote →</a>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-lg border border-amber-100">
              <div className="w-12 h-12 bg-amber-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-temp-hot-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Temperature Corpus</h3>
              <p className="text-gray-600 mb-4">
                WIKA Gauges Corpus Christi, All Temp Sensors Corpus, OCI Corpus, McDaniel Corpus
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">WIKA Corpus</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">All Temp Corpus</span>
                <span className="px-2 py-1 bg-amber-100 text-amber-800 text-sm rounded">OCI Corpus</span>
              </div>
              <a href="/contact" className="text-amber-600 hover:text-amber-700 font-medium">Get Corpus Quote →</a>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Ready to Sell Your Equipment in Corpus Christi?</h3>
              <p className="text-lg text-gray-600 mb-6">
                Contact us today for a free quote on your surplus refinery and petrochemical equipment in Corpus Christi, Texas
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="tel:2148545638" className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition duration-300">
                  Call (214) 854-5638
                </a>
                <a href="/contact" className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition duration-300">
                  Get Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves Corpus Christi */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">WE BUY SURPLUS VALVES CORPUS CHRISTI</h2>
            <p className="text-gray-600 text-xl">Corpus Christi's premier surplus valve buyers - serving South Texas</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Corpus%20Christi%20South%20Texas%20refinery%20surplus%20valves%20control%20valves%20gate%20valves%20ball%20valves%20Flint%20Hills%20Citgo%20coastal%20refinery%20equipment%20professional%20valve%20warehouse%20organized%20inventory&width=600&height=400&seq=corpus-christi-surplus-valves-014&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">South Texas Coastal Grade Valves</h3>
                  <p>Quality surplus valves from Corpus Christi's coastal refineries</p>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">CORPUS CHRISTI SURPLUS VALVE SPECIALISTS</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">Corpus Christi's leading surplus valve buyers</strong>, 
                we specialize in purchasing quality used valves from South Texas coastal refineries and 
                marine terminals. Our understanding of coastal operations and marine environments ensures 
                proper assessment of equipment exposed to Gulf Coast conditions.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Coastal Refinery Valves',
                    description: 'Fisher, Masoneilan from Flint Hills, Citgo coastal facilities',
                    icon: 'ri-ship-line'
                  },
                  {
                    type: 'Marine Terminal Valves',
                    description: 'Gate valves, ball valves from Corpus Christi port operations',
                    icon: 'ri-anchor-line'
                  },
                  {
                    type: 'Petrochemical Plant Valves',
                    description: 'Specialty valves from South Texas chemical operations',
                    icon: 'ri-flask-line'
                  },
                  {
                    type: 'Hurricane-Rated Equipment',
                    description: 'Heavy-duty valves designed for Gulf Coast weather',
                    icon: 'ri-cloudy-2-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-white rounded-lg p-6 border border-gray-200">
                <h4 className="text-[#1B3A5F] font-bold mb-3">Corpus Christi Coastal Advantage:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-ship-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Marine terminal expertise</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">2-4 hour response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-cloudy-2-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Hurricane preparedness</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Coastal operations experience</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">CORPUS CHRISTI VALVE BUYERS - FREQUENTLY ASKED QUESTIONS</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to South Texas buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CorpusChristi;
